module.exports = __webpack_public_path__ + "media/images/connected-5-68f00e1b35354de1719e2124e2085265.jpg";